import { Box, styled } from '@mui/joy';
import { SxProps } from '@mui/joy/styles/types';
import { CSSProperties } from 'react';

export const Wrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  gap: '16px',
  position: 'relative',
  minHeight: '300px',
});

// Hosts the grid together with its empty-state overlay. The empty state used to
// *replace* AgGridReact, which destroyed the grid while TopActions (rendered
// above it) still held the old api — gridApi is published from a ref, so it
// never re-synced. Consumers reading it during render then blanked the page, and
// the remounted grid never became ready. Overlaying keeps the grid mounted.
export const GridHost = styled(Box)({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto',
  minHeight: 0,
});

// Covers the grid area only, so the toolbar above stays clickable — the toggle
// that clears the empty state lives there.
export const emptyStateOverlayStyle: SxProps = {
  position: 'absolute',
  inset: 0,
  zIndex: 2,
  marginBottom: 0,
};

export const gridSlotStyle: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto',
  minHeight: 0,
};

// visibility rather than display, so the grid keeps its box while hidden: it
// stays mounted (the whole point — see GridHost) and needs no resize when it
// comes back. It also hides AG Grid's own "No Rows To Show", which would
// otherwise read through from underneath the empty state.
export const hiddenGridSlotStyle: SxProps = {
  ...gridSlotStyle,
  visibility: 'hidden',
};

export const progressBarStyle: CSSProperties = {
  position: 'absolute',
  width: '100%',
  bottom: 50,
  zIndex: 2,
};
